export default function NotFoundView() {
  return (
    <div className="flex min-h-screen items-center justify-center p-6 text-center">
      <div>
        <h1 className="text-3xl font-semibold mb-2">Page not found</h1>
        <p className="text-gray-400">That URL doesn't match a lobby route.</p>
      </div>
    </div>
  );
}
